import { useState, useEffect } from "react";

const ResendOtpModal = ({ show, onClose, type, onResend, error }) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    if (!show) setInput("");
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,0.5)", zIndex: 1050 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content p-3">
          <div className="d-flex mb-2 justify-content-between align-items-center">
            <h5 className="text-light">
              {type === "phone" ? "Verify Phone Number" : "Verify Email"}
            </h5>
            <i
              className="bi bi-x-lg text-light"
              style={{ cursor: "pointer" }}
              onClick={onClose}
            />
          </div>

          <input
            type={type === "phone" ? "tel" : "email"}
            className="form-control mb-2"
            placeholder={
              type === "phone"
                ? "Enter phone number"
                : "Enter email address"
            }
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />

          {error && (
            <div style={{ color: "red" }}>
              Account not verified.
            </div>
          )}

          <button
            className="btn btn-light text-info"
            style={{ width: "150px" }}
            onClick={() => onResend(input)}
          >
            Resend OTP
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResendOtpModal;
